// extracted by mini-css-extract-plugin
export var modal = "_em-0";